import { MapContainer, TileLayer, Marker, Polyline, Tooltip, useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) { map.setView(points[0], 13); return; }
    if (points.length > 1) { map.fitBounds(L.latLngBounds(points), { padding: [40, 40], maxZoom: 14 }); }
  }, [map, points]);
  return null;
}

const pin = (label, color) => L.divIcon({
  className: "",
  html: `<div style="background:${color};color:#fff;min-width:24px;height:24px;padding:0 5px;border-radius:12px 12px 12px 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center"><span style="transform:rotate(45deg);font-size:10px;font-weight:700;white-space:nowrap">${label}</span></div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 24],
});

// Business live map: laundry HQ + a pin at each driver's next uncompleted stop.
export default function LiveStopsMap({ hq, drivers }) {
  const hqc = hq?.coords;
  const stops = (drivers || []).filter((d) => d.next_stop && d.next_stop.coords);
  const pts = [];
  if (hqc) pts.push(hqc);
  stops.forEach((d) => pts.push(d.next_stop.coords));
  if (!pts.length) {
    return <div className="mt-3 rounded-xl border border-dashed border-slate-200 p-4 text-center text-xs text-slate-400" data-testid="live-map-empty">No mappable next stops right now.</div>;
  }
  const lat = pts.reduce((s, p) => s + p[0], 0) / pts.length;
  const lng = pts.reduce((s, p) => s + p[1], 0) / pts.length;

  return (
    <div className="mt-3 overflow-hidden rounded-xl border border-slate-200" data-testid="live-map">
      <MapContainer center={[lat, lng]} zoom={11} style={{ height: 260, width: "100%" }} scrollWheelZoom={false}>
        <FitBounds points={pts} />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        {hqc && <Marker position={hqc} icon={pin("HQ", "#0EA5A4")}><Tooltip>Your laundry</Tooltip></Marker>}
        {hqc && stops.map((d) => <Polyline key={`l-${d.driver_id}`} positions={[hqc, d.next_stop.coords]} pathOptions={{ color: "#94a3b8", weight: 1.5, dashArray: "4 5" }} />)}
        {stops.map((d) => (
          <Marker key={d.driver_id} position={d.next_stop.coords} icon={pin(d.name.split(" ")[0], "#F59E0B")}>
            <Tooltip><b>{d.name}</b><br />next: #{d.next_stop.order_ref} · {d.next_stop.client_name}</Tooltip>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
